import React from 'react';

// styling
import './Raffle.css';

// constants
import { RAFFLE_FIELDS } from './constants';

import TwoStepDelete from '../global/subcomponents/twoStepDelete/TwoStepDelete';

// mui components and icons
import { TableCell } from '@material-ui/core';
import TablePage from '../global/Table/TablePage';
import { Layout } from '../global/Table/TablePageHelpers/LayoutObject';

class RaffleTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteId: null,
    };
  }

  getTableHeaders = () => {
    let headers = [];
    RAFFLE_FIELDS.forEach((headCell) => {
      headers.push(Layout.columnHead(headCell.label, headCell.id));
    });
    headers.push(Layout.columnHead(null, null, null));
    return headers;
  };

  tableRow = (raffle, index) => {
    return (
      <React.Fragment>
        <TableCell className="table-cell-left" />

        <TableCell className="table-cell-left">
          {raffle?.files?.[0]?.localURL ? (
            <img
              src={raffle.files[0].localURL}
              alt="Raffle"
              className="responsive-image-customer"
            />
          ) : null}
        </TableCell>

        <TableCell className="table-cell-left">{raffle?.name}</TableCell>
        <TableCell className="table-cell-left">
          {raffle?.winnerNumber}
        </TableCell>
        <TableCell className="table-cell-left">{raffle?.amount}</TableCell>

        <TwoStepDelete
          rowId={raffle.raffleId}
          handleDelete={(rowIdToDelete) =>
            this.props.handleDeleteRow(raffle.raffleId)
          }
          deleteId={this.state.deleteId}
          setDeleteId={(newDeleteId) =>
            this.setState({ deleteId: newDeleteId })
          }
        />
      </React.Fragment>
    );
  };

  searchStrings = (raffle) => {
    return [raffle.name];
  };

  render() {
    return (
      <div className="raffle-table-container">
        <TablePage
          tableName="RaffleTable"
          tableRows={this.props.raffles}
          tableColumnHeads={this.getTableHeaders()}
          tableRow={this.tableRow}
          paginationText="Results"
          hasSearchField
          searchStrings={this.searchStrings}
          defaultSortBy="name"
        />
      </div>
    );
  }
}

export default RaffleTable;
